import Modal from "react-bootstrap/Modal";
import { MdRotateLeft, MdRotateRight } from "react-icons/md";
import { TfiSave } from "react-icons/tfi";
import LoadingSpinner from "../LoadingSpinner";
import styles from "../../pages/AddImages/styles.module.sass";

const ImagePreviewModal = ({
  showModal,
  closeModal,
  rotationVal,
  loading,
  rotateLeft,
  rotateRight,
  onSubmitRotate,
}) => {
  return (
    <Modal
      show={!!showModal}
      onHide={closeModal}
      aria-labelledby="example-modal-sizes-title-lg"
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <div className={styles.modalHeader}>
          <Modal.Title id="example-modal-sizes-title-lg">
            Pun Prikaz
          </Modal.Title>
          <div className={styles.rotateControls}>
            <MdRotateLeft
              fontSize={22}
              style={{ opacity: ".5" }}
              onClick={rotateLeft}
            />
            <MdRotateRight
              fontSize={22}
              style={{ opacity: ".5" }}
              onClick={rotateRight}
            />
            <TfiSave
              fontSize={20}
              style={{ opacity: ".5" }}
              onClick={onSubmitRotate}
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className={styles.modalLoader}>
            <LoadingSpinner />
          </div>
        ) : (
          <div className={styles.modalBody}>
            {showModal && (
              <img
                src={`${showModal.url}?${Math.random()}`}
                className={styles.previewImage}
                style={{ transform: `rotate(${rotationVal}deg)` }}
                alt=""
              />
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ImagePreviewModal;
